import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-panel-main page-home" }
const _hoisted_2 = { class: "main-body" }
const _hoisted_3 = { class: "container-page scroll-thin-custom" }

import LoginService from '@/core/services/login/LoginService';
import CloseSesionView from './CloseSesionView.vue';
import MenuVComponent from './MenuVComponent.vue';
import ToolbarView from './ToolbarView.vue';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import { computed, onMounted, ref } from 'vue';
import { ISesionApp, SesionApp } from '@/core/model/sesion/ISesionApp';
import { useRouter } from 'vue-router';
import { eAppPaths, eRolAppUsuario } from '@/core/model/GloblasEnum';
import menus from '@/assets/config/app-menus-cliente.json';
import { useMainStore } from '@/core/stores/main-store';
import { jwtDecode } from "jwt-decode";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWebMainSocioComponent',
  setup(__props) {

const router = useRouter();
const loginService:LoginService = useServicesFactoryStore().getLoginService;
const sesion = ref<ISesionApp>(new SesionApp());
const smallMode = ref<boolean>(false);
const showMnuBurgerFull = ref<boolean>(false);
const mainStore = useMainStore();
const version = ref<string>(mainStore.getAppConfig.version);

const closeSesion = async () =>
{
    const type = sesion.value.Type;
    await loginService.CloseSesion();
    if(type === eRolAppUsuario.Cliente)
        router.replace({name:eAppPaths.loginSocio});
}
const onMenu = ()=>
{
    smallMode.value = false;
    showMnuBurgerFull.value=true;

}
const ToggleMenu = () =>
{
    smallMode.value = !smallMode.value;
    showMnuBurgerFull.value=false;
}

const ExpirationDate = computed(():Date => 
{
    const decoded = jwtDecode(sesion.value.Token);
    if(decoded.exp)
    {
        
        const utcDate = new Date(decoded.exp * 1000);
        return utcDate;
       /* return new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate(),
    utcDate.getUTCHours(),
    utcDate.getUTCMinutes(),
    utcDate.getUTCSeconds(),
    utcDate.getUTCMilliseconds(),
  );   */    
    }
    else
        return new Date();
});
onMounted(async ()=>
{                   
    sesion.value = await loginService.getSession();        
    const hoy = new Date();    
    if(ExpirationDate.value < hoy)
    {
        closeSesion();
    }
    window.scrollTo(0, 0);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["main-body-menu", {'smallMode':smallMode.value,'normalMode':!smallMode.value,'BurgerFull':showMnuBurgerFull.value}])
      }, [
        _createElementVNode("div", {
          class: "menu",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
        }, [
          _createElementVNode("div", {
            class: "menu-logo",
            onClick: ToggleMenu
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "title" }, [
              _createElementVNode("span", null, [
                _createElementVNode("span", null, "San Pedro Pozohuacan")
              ])
            ], -1),
            _createElementVNode("div", { class: "pointer bars" }, [
              _createElementVNode("i", { class: "pi pi-bars" })
            ], -1)
          ])),
          _createVNode(MenuVComponent, {
            go: true,
            menus: _unref(menus),
            smallMode: smallMode.value,
            onOnClickMenu: _cache[0] || (_cache[0] = ($event: any) => (showMnuBurgerFull.value=false))
          }, null, 8, ["menus", "smallMode"]),
          _createVNode(CloseSesionView, {
            version: version.value,
            onOnClose: closeSesion
          }, null, 8, ["version"])
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["main-body-content", {'smallModeBody':!smallMode.value,'normalModeBody':smallMode.value,'BodyHiden':showMnuBurgerFull.value}])
      }, [
        (sesion.value && sesion.value.Gid)
          ? (_openBlock(), _createBlock(ToolbarView, {
              key: 0,
              sesion: sesion.value,
              onOnMenu: onMenu
            }, null, 8, ["sesion"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_view)
        ])
      ], 2)
    ])
  ]))
}
}

})